import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { useLocation } from 'react-router-dom';
import { isMarketingProductPath } from '../../utils/marketingProduct';
import { isMarketingPostDesignPath } from '../modules/Marketing/constants/MarketingNavConstants';
import MarketingGlobalSidebarMC from '../sidebars/shared/MarketingGlobalSidebarMC';

const CRM_SIDEBAR_PC_ID = 'sidebar-pc-wrapper';
const CRM_SIDEBAR_MOBILE_ID = 'sidebar';
const MARKETING_SIDEBAR_PC_ID = 'marketing-sidebar-pc-wrapper';
const MARKETING_SIDEBAR_MOBILE_ID = 'marketing-sidebar';
const HELP_CENTER_BAR_ID = 'helpCenterBarErb';
const HEADER_CALENDAR_BUTTON_ID = 'header-calendar-button';
const SIDEBAR_TOGGLE_LABEL_SELECTOR = '.dropdown__button.hide-on-pc label';

const setElementVisible = (elementId, visible) => {
  const element = document.getElementById(elementId);
  if (!element) return;

  if (visible) {
    element.classList.remove('d-none');
    element.style.removeProperty('display');
  } else {
    element.classList.add('d-none');
    element.style.display = 'none';
  }
};

const setHeaderCalendarVisible = (visible) => {
  const element = document.getElementById(HEADER_CALENDAR_BUTTON_ID);
  if (!element) return;

  element.classList.toggle('not-show', !visible);
};

const MarketingSidebarSyncMC = () => {
  const location = useLocation();
  const isImmersiveDesignEditor = isMarketingPostDesignPath(location.pathname);
  const marketingActive = isMarketingProductPath(location.pathname) && !isImmersiveDesignEditor;
  const [showReactSidebar, setShowReactSidebar] = useState(false);

  useEffect(() => {
    const inMarketing = isMarketingProductPath(location.pathname);
    setHeaderCalendarVisible(!inMarketing);

    if (isImmersiveDesignEditor) {
      setElementVisible(CRM_SIDEBAR_PC_ID, false);
      setElementVisible(CRM_SIDEBAR_MOBILE_ID, false);
      setElementVisible(MARKETING_SIDEBAR_PC_ID, false);
      setElementVisible(MARKETING_SIDEBAR_MOBILE_ID, false);
      setElementVisible(HELP_CENTER_BAR_ID, false);
      setShowReactSidebar(false);
      return;
    }

    setElementVisible(CRM_SIDEBAR_PC_ID, !marketingActive);
    setElementVisible(CRM_SIDEBAR_MOBILE_ID, !marketingActive);
    setElementVisible(MARKETING_SIDEBAR_PC_ID, marketingActive);
    setElementVisible(MARKETING_SIDEBAR_MOBILE_ID, marketingActive);
    setElementVisible(HELP_CENTER_BAR_ID, true);

    const marketingPcWrapper = document.getElementById(MARKETING_SIDEBAR_PC_ID);
    setShowReactSidebar(marketingActive && !marketingPcWrapper);

    const toggleLabel = document.querySelector(SIDEBAR_TOGGLE_LABEL_SELECTOR);
    if (toggleLabel) {
      toggleLabel.setAttribute('for', marketingActive ? 'marketing-sidebar--toggle' : 'sidebar--toggle');
    }

    const sidebarToggle = document.getElementById('sidebar--toggle');
    const marketingSidebarToggle = document.getElementById('marketing-sidebar--toggle');
    if (sidebarToggle) sidebarToggle.checked = false;
    if (marketingSidebarToggle) marketingSidebarToggle.checked = false;
  }, [marketingActive, isImmersiveDesignEditor, location.pathname]);

  if (!showReactSidebar) return null;

  return createPortal(<MarketingGlobalSidebarMC />, document.body);
};

export default MarketingSidebarSyncMC;
